// extracted by mini-css-extract-plugin
export default {"container":"NN-z","modal":"ON-z","dimensions":"PN-z","brandName":"QN-z","productName":"RN-z","labelValue":"SN-z","recipientEmail":"TN-z","recommendedFit":"UN-z","hiddenField":"VN-z"};